import { APPROVAL_PHASE } from "../approval-phase.types";
/**
 * @description 승인 단계 상향 함수를
 *
 * @param { APPROVAL_PHASE } nowPhase - 현재 승인 단계
 * @param { boolean } isApproved - 승인 여부
 */
export function upgradeApprovalStep(nowPhase, isApproved) {
    if (!isApproved) {
        return APPROVAL_PHASE.반려;
    }
    if (nowPhase === APPROVAL_PHASE.미확인) {
        return APPROVAL_PHASE.미승인;
    }
    else if (nowPhase === APPROVAL_PHASE.미승인) {
        return APPROVAL_PHASE.승인;
    }
    return APPROVAL_PHASE.잘못된승인단계; // 잘못된 승인 단계
}
